import { createBlock } from 'factories/block';
import { createLayout } from 'factories/layout';
import { createContinueBtn } from './continueBtn';
import { getSId } from '../utils';

const contentForColumn = (count: number) => (i: number) => {
  return [
    () => createBlock('Text', [], { props: { useBackgroundControls: true } }),
    () => createBlock('TopicPortalContainer', [], {}),
  ][i];
};

export const createTopicPortalInteractionBlock = props => {
  const { style } = props as any;

  //

  return createBlock(
    'Interaction',
    [
      createLayout(contentForColumn(0), 0, true),
      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        name: props.name,
        sId: getSId('interaction'),
        style: props.style,
      },
      meta: {
        subType: 'TopicPortal',
        layout: 'OneColumnReversed',
      },
    }
  );
};

export const create = createTopicPortalInteractionBlock;
export const interactionConfig = {};
